import { IAccordionData } from "@/models/IAccordionData";
import CapabilitiesTextContainer from "../../components/capabilitiesTextContainer";
import AccordionWrapper from "../../components/accordionWrapper";
import s1Icon1 from "../../assets/icons/capabilities-regulatory-s1-1.png";
import s1Icon2 from "../../assets/icons/capabilities-regulatory-s1-2.png";
import s1Icon3 from "../../assets/icons/capabilities-regulatory-s1-3.png";
import s1Icon4 from "../../assets/icons/capabilities-regulatory-s1-4.png";
import s1Icon5 from "../../assets/icons/capabilities-regulatory-s1-5.png";
import s1Icon6 from "../../assets/icons/capabilities-regulatory-s1-6.png";

const accordionDataRaw = [
  {
    header: "Regulatory",
    description: "Demystifying regulatory interactions",
    data: [
      {
        headerSection: "",
        icon: (
          <img
            src={s1Icon1}
            alt="A magnifying glass being used on a document with an outline of three people below"
            className="h-24"
          />
        ),
        header:
          "What to Expect When you File an Investigational New Drug/Clinical Trial Application (IND/CTA)",
        data: [
          "IND/CTA roadmap",
          "Description of overall process",
          "General table of contents",
          "General timeline with key milestones identified ",
        ],
      },
      {
        headerSection: "",
        icon: (
          <img
            src={s1Icon2}
            alt="A document that is being stamped"
            className="h-24"
          />
        ),
        header: "IND/CTA Applications",
        data: [
          "Table of contents and timelines for IND/CTA",
          "Highlight gaps in the data package",
          "Risk analysis, with mitigation and contingency plans",
          "Create IND/CTA package",
          "Medical writing and regulatory submission support",
          "Submit IND/CTA",
          "Assist with CT.gov registry requirements",
        ],
      },
      {
        headerSection: "",
        icon: <img src={s1Icon3} alt="A balance" className="h-24" />,
        header: "Regulatory Strategy",
        data: [
          "Advise on geography",
          "Identify unique requirements",
          "Recommend expedited pathways, if appropriate",
          "Recommend meetings with regulators, if appropriate",
          "Risk analysis, with mitigation and contingency plans",
        ],
      },
      {
        headerSection: "",
        icon: (
          <img
            src={s1Icon4}
            alt="Three people in a discussion"
            className="h-24"
          />
        ),
        header: "Conduct Meetings with Regulators",
        data: [
          "Assess eligibility for expedited pathways; recommend path",
          "Table of contents for briefing package with draft questions",
          "Review draft documents",
          "Provide advice to address gaps",
          "Prepare meeting request ",
          "Prepare briefing package",
          "Conduct meeting",
          "Advise on next steps",
        ],
      },
      {
        headerSection: "",
        icon: <img src={s1Icon5} alt="Three pills" className="h-24" />,
        header: "Orphan Drug Designation (ODD)",
        data: [
          "ODD roadmap",
          "Benefits and limitations",
          "Implications to commercialization strategy",
          "Review draft documents",
          "Provide advice to address gaps",
          "Prepare request",
          "Support response to questions during review",
          "Advise on next steps, including required maintenance activities",
        ],
      },
      {
        headerSection: "",
        icon: (
          <img src={s1Icon6} alt="A graph line going up" className="h-24" />
        ),
        header: "Regulatory Intelligence",
        data: [
          "Disease states",
          "Approved therapies",
          "Strategic approaches",
          "Analysis of labels",
          "Review division differences",
          "Global regulatory agency differences",
        ],
      },
    ],
  },
];
const Regulatory = (props: {
  accordionOpenHeader: string;
  setAccordionOpenHeader: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const accordionData: IAccordionData[] = [
    //Regulatory
    {
      header: accordionDataRaw[0].header,
      body: (
        <div className="px-4 py-4">
          <div className="text-xl font-light max-w-[40rem] capitalize">
            {accordionDataRaw[0].description}
          </div>
          <div className="my-8 grid xl:grid-cols-3 grid-cols-1 gap-4 xl:gap-2 items-center h-full">
            {accordionDataRaw[0].data.map((el, index) => (
              <div className="h-full">
                <CapabilitiesTextContainer>
                  <div className="p-4">
                    <div className="w-full mt-2 mb-4 flex justify-center">
                      {el.icon}
                    </div>
                    <div className="font-medium mb-4">{el.header}</div>
                    <div>
                      {el.data.map((point) => (
                        <div className="border-t border-border-gray20 py-2">
                          {point}
                        </div>
                      ))}
                    </div>
                  </div>
                </CapabilitiesTextContainer>
              </div>
            ))}
          </div>
        </div>
      ),
    },
  ];
  return (
    <AccordionWrapper
      data={accordionData}
      setOpen={props.setAccordionOpenHeader}
      accordionOpenHeader={props.accordionOpenHeader}
    />
  );
};

export default Regulatory;
